<template>
  <eg-modal
    id="delete-modal"
    :title="title || $t('common.deleteItem')"
    size="md"
    centered
    style="z-index: var(--layout-z-index-modal)"
  >
    <template #modal-footer="{ close }">
      <div class="d-flex align-items-center justify-content-end">
        <eg-button type="secondary" @click="close">{{
          $t("common.back")
        }}</eg-button>
        <eg-button
          class="ml-2"
          :is-loading="loading"
          :loading-text="$t('common.deleting')"
          type="primary"
          color="danger"
          :disabled="
            confirmTextValue === '' ? false : confirmValue !== confirmTextValue
          "
          @click="deleteAction"
        >
          {{ $t("common.delete") }}
        </eg-button>
      </div>
    </template>

    <div class="delete-modal-content">
      <eg-icon class="mr-3" icon="risk-warning-error-danger"> </eg-icon>

      <span class="delete-modal-content-text">
        {{ message || $t("common.deleteItemMessage") }}
      </span>
    </div>

    <div v-if="confirmTextLabel && confirmTextValue" class="mt-4">
      <div class="confirm-text-container">
        <div class="paragraph-s medium">
          {{ confirmTextLabel }}
        </div>

        <eg-b-form-input v-model="confirmValue" />
      </div>
    </div>
  </eg-modal>
</template>

<script>
import EgButton from "@/components/global/eg/buttons/eg_button.vue";
import EgIcon from "@/components/global/eg/eg_icon.vue";

export default {
  name: "DeleteModal",
  components: {
    EgButton,
    EgIcon,
  },

  props: {
    name: {
      type: String,
      default: "",
    },
    message: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
    action: {
      type: Function,
      default: null,
    },
    resolve: {
      type: Function,
      default: null,
    },
    confirmTextLabel: {
      type: String,
      default: "",
    },
    confirmTextValue: {
      type: String,
      default: "",
    },
  },

  data() {
    return {
      loading: false,
      confirmValue: null,
    };
  },

  methods: {
    onHidden() {
      this.$emit("close");
    },

    async deleteAction() {
      if (!this.action) {
        this.resolve && this.resolve(true);
        this.$egModal.hide("delete-modal");

        return;
      }

      this.loading = true;

      try {
        await this.action();

        this.resolve && this.resolve(true);
        this.$egModal.hide("delete-modal");
        this.$showToastSuccess(
          this.$t("common.itemDeletedSuccessfully", {
            item: this.name || this.$t("common.deleteItem"),
          }),
          { title: this.$t("common.success") }
        );
      } catch (error) {
        this.$showToastError(
          error?.response?.data?.error || this.$t("common.failedToDelete")
        );
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.delete-modal-content {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--color-surface-semantic-error-light);
  padding: 20px 24px;
  border-radius: var(--radius-rd-400);

  .delete-modal-content-text {
    color: var(--colors-red-500);
  }

  .eg-icon {
    color: var(--colors-red-500) !important;
  }
}

.confirm-text-container {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
</style>

<style lang="scss">
#delete-modal {
  .eg-modal__body {
    padding: 24px !important;
  }
}
</style>
